/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal.js";
export const protobufPackage = "injective.evm.v1";
function createBaseChainConfig() {
    return {
        homesteadBlock: "",
        daoForkBlock: "",
        daoForkSupport: false,
        eip150Block: "",
        eip150Hash: "",
        eip155Block: "",
        eip158Block: "",
        byzantiumBlock: "",
        constantinopleBlock: "",
        petersburgBlock: "",
        istanbulBlock: "",
        muirGlacierBlock: "",
        berlinBlock: "",
        londonBlock: "",
        arrowGlacierBlock: "",
        grayGlacierBlock: "",
        mergeNetsplitBlock: "",
        shanghaiTime: "",
        cancunTime: "",
        pragueTime: "",
        eip155ChainId: "",
        blobScheduleConfig: undefined,
    };
}
export const ChainConfig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.homesteadBlock !== "") {
            writer.uint32(10).string(message.homesteadBlock);
        }
        if (message.daoForkBlock !== "") {
            writer.uint32(18).string(message.daoForkBlock);
        }
        if (message.daoForkSupport === true) {
            writer.uint32(24).bool(message.daoForkSupport);
        }
        if (message.eip150Block !== "") {
            writer.uint32(34).string(message.eip150Block);
        }
        if (message.eip150Hash !== "") {
            writer.uint32(42).string(message.eip150Hash);
        }
        if (message.eip155Block !== "") {
            writer.uint32(50).string(message.eip155Block);
        }
        if (message.eip158Block !== "") {
            writer.uint32(58).string(message.eip158Block);
        }
        if (message.byzantiumBlock !== "") {
            writer.uint32(66).string(message.byzantiumBlock);
        }
        if (message.constantinopleBlock !== "") {
            writer.uint32(74).string(message.constantinopleBlock);
        }
        if (message.petersburgBlock !== "") {
            writer.uint32(82).string(message.petersburgBlock);
        }
        if (message.istanbulBlock !== "") {
            writer.uint32(90).string(message.istanbulBlock);
        }
        if (message.muirGlacierBlock !== "") {
            writer.uint32(98).string(message.muirGlacierBlock);
        }
        if (message.berlinBlock !== "") {
            writer.uint32(106).string(message.berlinBlock);
        }
        if (message.londonBlock !== "") {
            writer.uint32(138).string(message.londonBlock);
        }
        if (message.arrowGlacierBlock !== "") {
            writer.uint32(146).string(message.arrowGlacierBlock);
        }
        if (message.grayGlacierBlock !== "") {
            writer.uint32(162).string(message.grayGlacierBlock);
        }
        if (message.mergeNetsplitBlock !== "") {
            writer.uint32(170).string(message.mergeNetsplitBlock);
        }
        if (message.shanghaiTime !== "") {
            writer.uint32(178).string(message.shanghaiTime);
        }
        if (message.cancunTime !== "") {
            writer.uint32(186).string(message.cancunTime);
        }
        if (message.pragueTime !== "") {
            writer.uint32(194).string(message.pragueTime);
        }
        if (message.eip155ChainId !== "") {
            writer.uint32(202).string(message.eip155ChainId);
        }
        if (message.blobScheduleConfig !== undefined) {
            BlobScheduleConfig.encode(message.blobScheduleConfig, writer.uint32(210).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChainConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.homesteadBlock = reader.string();
                    break;
                case 2:
                    message.daoForkBlock = reader.string();
                    break;
                case 3:
                    message.daoForkSupport = reader.bool();
                    break;
                case 4:
                    message.eip150Block = reader.string();
                    break;
                case 5:
                    message.eip150Hash = reader.string();
                    break;
                case 6:
                    message.eip155Block = reader.string();
                    break;
                case 7:
                    message.eip158Block = reader.string();
                    break;
                case 8:
                    message.byzantiumBlock = reader.string();
                    break;
                case 9:
                    message.constantinopleBlock = reader.string();
                    break;
                case 10:
                    message.petersburgBlock = reader.string();
                    break;
                case 11:
                    message.istanbulBlock = reader.string();
                    break;
                case 12:
                    message.muirGlacierBlock = reader.string();
                    break;
                case 13:
                    message.berlinBlock = reader.string();
                    break;
                case 17:
                    message.londonBlock = reader.string();
                    break;
                case 18:
                    message.arrowGlacierBlock = reader.string();
                    break;
                case 20:
                    message.grayGlacierBlock = reader.string();
                    break;
                case 21:
                    message.mergeNetsplitBlock = reader.string();
                    break;
                case 22:
                    message.shanghaiTime = reader.string();
                    break;
                case 23:
                    message.cancunTime = reader.string();
                    break;
                case 24:
                    message.pragueTime = reader.string();
                    break;
                case 25:
                    message.eip155ChainId = reader.string();
                    break;
                case 26:
                    message.blobScheduleConfig = BlobScheduleConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            homesteadBlock: isSet(object.homesteadBlock) ? String(object.homesteadBlock) : "",
            daoForkBlock: isSet(object.daoForkBlock) ? String(object.daoForkBlock) : "",
            daoForkSupport: isSet(object.daoForkSupport) ? Boolean(object.daoForkSupport) : false,
            eip150Block: isSet(object.eip150Block) ? String(object.eip150Block) : "",
            eip150Hash: isSet(object.eip150Hash) ? String(object.eip150Hash) : "",
            eip155Block: isSet(object.eip155Block) ? String(object.eip155Block) : "",
            eip158Block: isSet(object.eip158Block) ? String(object.eip158Block) : "",
            byzantiumBlock: isSet(object.byzantiumBlock) ? String(object.byzantiumBlock) : "",
            constantinopleBlock: isSet(object.constantinopleBlock) ? String(object.constantinopleBlock) : "",
            petersburgBlock: isSet(object.petersburgBlock) ? String(object.petersburgBlock) : "",
            istanbulBlock: isSet(object.istanbulBlock) ? String(object.istanbulBlock) : "",
            muirGlacierBlock: isSet(object.muirGlacierBlock) ? String(object.muirGlacierBlock) : "",
            berlinBlock: isSet(object.berlinBlock) ? String(object.berlinBlock) : "",
            londonBlock: isSet(object.londonBlock) ? String(object.londonBlock) : "",
            arrowGlacierBlock: isSet(object.arrowGlacierBlock) ? String(object.arrowGlacierBlock) : "",
            grayGlacierBlock: isSet(object.grayGlacierBlock) ? String(object.grayGlacierBlock) : "",
            mergeNetsplitBlock: isSet(object.mergeNetsplitBlock) ? String(object.mergeNetsplitBlock) : "",
            shanghaiTime: isSet(object.shanghaiTime) ? String(object.shanghaiTime) : "",
            cancunTime: isSet(object.cancunTime) ? String(object.cancunTime) : "",
            pragueTime: isSet(object.pragueTime) ? String(object.pragueTime) : "",
            eip155ChainId: isSet(object.eip155ChainId) ? String(object.eip155ChainId) : "",
            blobScheduleConfig: isSet(object.blobScheduleConfig)
                ? BlobScheduleConfig.fromJSON(object.blobScheduleConfig)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.homesteadBlock !== undefined && (obj.homesteadBlock = message.homesteadBlock);
        message.daoForkBlock !== undefined && (obj.daoForkBlock = message.daoForkBlock);
        message.daoForkSupport !== undefined && (obj.daoForkSupport = message.daoForkSupport);
        message.eip150Block !== undefined && (obj.eip150Block = message.eip150Block);
        message.eip150Hash !== undefined && (obj.eip150Hash = message.eip150Hash);
        message.eip155Block !== undefined && (obj.eip155Block = message.eip155Block);
        message.eip158Block !== undefined && (obj.eip158Block = message.eip158Block);
        message.byzantiumBlock !== undefined && (obj.byzantiumBlock = message.byzantiumBlock);
        message.constantinopleBlock !== undefined && (obj.constantinopleBlock = message.constantinopleBlock);
        message.petersburgBlock !== undefined && (obj.petersburgBlock = message.petersburgBlock);
        message.istanbulBlock !== undefined && (obj.istanbulBlock = message.istanbulBlock);
        message.muirGlacierBlock !== undefined && (obj.muirGlacierBlock = message.muirGlacierBlock);
        message.berlinBlock !== undefined && (obj.berlinBlock = message.berlinBlock);
        message.londonBlock !== undefined && (obj.londonBlock = message.londonBlock);
        message.arrowGlacierBlock !== undefined && (obj.arrowGlacierBlock = message.arrowGlacierBlock);
        message.grayGlacierBlock !== undefined && (obj.grayGlacierBlock = message.grayGlacierBlock);
        message.mergeNetsplitBlock !== undefined && (obj.mergeNetsplitBlock = message.mergeNetsplitBlock);
        message.shanghaiTime !== undefined && (obj.shanghaiTime = message.shanghaiTime);
        message.cancunTime !== undefined && (obj.cancunTime = message.cancunTime);
        message.pragueTime !== undefined && (obj.pragueTime = message.pragueTime);
        message.eip155ChainId !== undefined && (obj.eip155ChainId = message.eip155ChainId);
        message.blobScheduleConfig !== undefined && (obj.blobScheduleConfig = message.blobScheduleConfig
            ? BlobScheduleConfig.toJSON(message.blobScheduleConfig)
            : undefined);
        return obj;
    },
    create(base) {
        return ChainConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChainConfig();
        message.homesteadBlock = object.homesteadBlock ?? "";
        message.daoForkBlock = object.daoForkBlock ?? "";
        message.daoForkSupport = object.daoForkSupport ?? false;
        message.eip150Block = object.eip150Block ?? "";
        message.eip150Hash = object.eip150Hash ?? "";
        message.eip155Block = object.eip155Block ?? "";
        message.eip158Block = object.eip158Block ?? "";
        message.byzantiumBlock = object.byzantiumBlock ?? "";
        message.constantinopleBlock = object.constantinopleBlock ?? "";
        message.petersburgBlock = object.petersburgBlock ?? "";
        message.istanbulBlock = object.istanbulBlock ?? "";
        message.muirGlacierBlock = object.muirGlacierBlock ?? "";
        message.berlinBlock = object.berlinBlock ?? "";
        message.londonBlock = object.londonBlock ?? "";
        message.arrowGlacierBlock = object.arrowGlacierBlock ?? "";
        message.grayGlacierBlock = object.grayGlacierBlock ?? "";
        message.mergeNetsplitBlock = object.mergeNetsplitBlock ?? "";
        message.shanghaiTime = object.shanghaiTime ?? "";
        message.cancunTime = object.cancunTime ?? "";
        message.pragueTime = object.pragueTime ?? "";
        message.eip155ChainId = object.eip155ChainId ?? "";
        message.blobScheduleConfig = (object.blobScheduleConfig !== undefined && object.blobScheduleConfig !== null)
            ? BlobScheduleConfig.fromPartial(object.blobScheduleConfig)
            : undefined;
        return message;
    },
};
function createBaseBlobScheduleConfig() {
    return { cancun: undefined, prague: undefined, osaka: undefined, verkle: undefined };
}
export const BlobScheduleConfig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.cancun !== undefined) {
            BlobConfig.encode(message.cancun, writer.uint32(10).fork()).ldelim();
        }
        if (message.prague !== undefined) {
            BlobConfig.encode(message.prague, writer.uint32(18).fork()).ldelim();
        }
        if (message.osaka !== undefined) {
            BlobConfig.encode(message.osaka, writer.uint32(26).fork()).ldelim();
        }
        if (message.verkle !== undefined) {
            BlobConfig.encode(message.verkle, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlobScheduleConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cancun = BlobConfig.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.prague = BlobConfig.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.osaka = BlobConfig.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.verkle = BlobConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            cancun: isSet(object.cancun) ? BlobConfig.fromJSON(object.cancun) : undefined,
            prague: isSet(object.prague) ? BlobConfig.fromJSON(object.prague) : undefined,
            osaka: isSet(object.osaka) ? BlobConfig.fromJSON(object.osaka) : undefined,
            verkle: isSet(object.verkle) ? BlobConfig.fromJSON(object.verkle) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.cancun !== undefined && (obj.cancun = message.cancun ? BlobConfig.toJSON(message.cancun) : undefined);
        message.prague !== undefined && (obj.prague = message.prague ? BlobConfig.toJSON(message.prague) : undefined);
        message.osaka !== undefined && (obj.osaka = message.osaka ? BlobConfig.toJSON(message.osaka) : undefined);
        message.verkle !== undefined && (obj.verkle = message.verkle ? BlobConfig.toJSON(message.verkle) : undefined);
        return obj;
    },
    create(base) {
        return BlobScheduleConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlobScheduleConfig();
        message.cancun = (object.cancun !== undefined && object.cancun !== null)
            ? BlobConfig.fromPartial(object.cancun)
            : undefined;
        message.prague = (object.prague !== undefined && object.prague !== null)
            ? BlobConfig.fromPartial(object.prague)
            : undefined;
        message.osaka = (object.osaka !== undefined && object.osaka !== null)
            ? BlobConfig.fromPartial(object.osaka)
            : undefined;
        message.verkle = (object.verkle !== undefined && object.verkle !== null)
            ? BlobConfig.fromPartial(object.verkle)
            : undefined;
        return message;
    },
};
function createBaseBlobConfig() {
    return { target: "0", max: "0", baseFeeUpdateFraction: "0" };
}
export const BlobConfig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.target !== "0") {
            writer.uint32(8).uint64(message.target);
        }
        if (message.max !== "0") {
            writer.uint32(16).uint64(message.max);
        }
        if (message.baseFeeUpdateFraction !== "0") {
            writer.uint32(24).uint64(message.baseFeeUpdateFraction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlobConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.target = longToString(reader.uint64());
                    break;
                case 2:
                    message.max = longToString(reader.uint64());
                    break;
                case 3:
                    message.baseFeeUpdateFraction = longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            target: isSet(object.target) ? String(object.target) : "0",
            max: isSet(object.max) ? String(object.max) : "0",
            baseFeeUpdateFraction: isSet(object.baseFeeUpdateFraction) ? String(object.baseFeeUpdateFraction) : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        message.target !== undefined && (obj.target = message.target);
        message.max !== undefined && (obj.max = message.max);
        message.baseFeeUpdateFraction !== undefined && (obj.baseFeeUpdateFraction = message.baseFeeUpdateFraction);
        return obj;
    },
    create(base) {
        return BlobConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlobConfig();
        message.target = object.target ?? "0";
        message.max = object.max ?? "0";
        message.baseFeeUpdateFraction = object.baseFeeUpdateFraction ?? "0";
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
